"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var SOCIAL_NETWORKS = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  PINTEREST: 'pinterest',
  EMAIL: 'email',
  TUMBLR: 'tumblr'
};
var _default = SOCIAL_NETWORKS;
exports["default"] = _default;